import React from 'react';

import Skeleton from 'components/skeleton';

const LayoutHeaderSkeleton = () => {
  return <Skeleton style={{ height: 20, width: 160 }} />;
};

export default LayoutHeaderSkeleton;
